<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <limitation-card
      :type="getType"
      :formData="formData"
      :jarRoles="jarRoles"
      :amntTypes="amntTypes"
      :jaLegalStatus="jaLegalStatus"
      :fateIds="fateIds"
      :nirvars="nirvars"
      :jarForms="jarForms"
      :loading="loading"
      @move-to-selected="moveToSelected"
      @move-to-available="moveToAvailable"
      @save="saveData"
      @back="back"
    />
    <!-- modal  -->
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import LimitationTypes from '@/components/constants/rcSesLimitationTypes.js'
import {classifiersGet} from "@/services/classifierService";
import LimitationCard from '../limitationCard/LimitationCard.vue';

export default {
  components: { LimitationCard },
  name: 'ServiceLimitationForm',
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      enumsClassifiers: [],
      formData: {},
      code: '',
      jarRoles: [],
      amntTypes: [],
      jaLegalStatus: [],
      fateIds: [],
      nirvars: [],
      jarForms: [],
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      return 'Redaguoti paslaugos apribojimus'
    },
    getType() {
      return LimitationTypes.Service
    }
  },
  created() {
    this.enumsClassifiers = Enums
    if (window.localStorage.getItem('presetCK') === '1') {
      window.localStorage.setItem('presetCK', '0')
      location.reload()
    }
    this.getData()
  },
  mounted() {},
  beforeDestroy() {
    window.localStorage.setItem('presetCK', '1')
  },
  methods: {
    onNamespaceLoaded(CKEDITOR) {
      var that = this
      CKEDITOR.plugins.add('customParameterButtons', {
        init: function (editor) {
          // all btns
          if(!that.formData.available_buttons){ return }
          that.formData.available_buttons.map((button) => {
            // fnc
            editor.addCommand(`${button.key.toLowerCase()}_fnc`, {
              exec: function (editor) {
                editor.insertHtml(`${button.value}`)
                // editor.insertHtml(`<input type="text" value="${button.value}" class="field left" readonly>`)
              },
            })
            // btn
            editor.ui.addButton(`${button.key.toLowerCase()}_name`, {
              icon: '/static/add-ck.png',
              label: `${button.placeholder}`,
              command: `${button.key.toLowerCase()}_fnc`,
              toolbar: 'customInsert',
            })
            // style
            var style = document.createElement('style')
            style.innerHTML = `.cke_button__${`${button.key.toLowerCase()}_name`}_label { display:inline !important; }`
            document.getElementsByTagName('head')[0].appendChild(style)
          })
        },
      })
    },
    setEdit(item) {
      return item
    },
    back() {
      this.$router.push({ name: 'serviceLimitation' })
    },
    async getClassifiers() {
      this.enumsClassifiers = Enums
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['kada-jar-role', 'amnt-types', 'jar-status', 'ipas_ja_permission', 'nirvar', 'jar-form'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.jarRoles = res.data.classifiers['kada-jar-role']['lt'].sort((a, b) => a.value - b.value)
          this.amntTypes = res.data.classifiers['amnt-types']['lt'].sort((a, b) => a.value - b.value)
          this.jaLegalStatus = res.data.classifiers['jar-status']['lt'].sort((a, b) => a.value - b.value)
          this.fateIds = res.data.classifiers['ipas_ja_permission']['lt'].sort((a, b) => a.fate - b.fate)
          this.jarForms = res.data.classifiers['jar-form']['lt'].sort((a, b) => a.value - b.value)
          this.nirvars = res.data.classifiers['nirvar']['lt']
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
      classifiersGet({ classifiers: ['nirvar']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    async getData() {
      await this.getClassifiers()
      this.pageloading = true
      this.$axios
        .get(`rc-ses-limitations/${this.getId}`)
        .then((res) => {
          this.formData = res.data.rcSesLimitation
          this.code = this.formData.code
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          formData.code = this.code
          let url = `rc-ses-limitations/${this.getId}`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    moveToSelected(itemToSelect, key) {
      if (!this.formData[key].includes(itemToSelect.value)) {
        this.formData[key].push(itemToSelect.value);
      }

      if (key === 'nirvars') {
        this.formData[key].sort((a, b) => {
          const itemA = this.nirvars.find(item => item.value === a);
          const itemB = this.nirvars.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.text.localeCompare(itemB.text);
          }
          return 0; // Keep original order if items not found
        });
      } else if (key == 'fate_ids') {
        this.formData[key].sort((a, b) => {
          const itemA = this.fateIds.find(item => item.value === a);
          const itemB = this.fateIds.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.fate - itemB.fate;
          }
          return 0; // Keep original order if items not found
        });
      } else {
        this.formData[key].sort((a, b) => a - b);
      }
    },
    moveToAvailable(itemToRemove, key) {
      const indexToRemove = this.formData[key].indexOf(itemToRemove.value);
      if (indexToRemove > -1) {
        this.formData[key].splice(indexToRemove, 1);
      }

      if (key === 'nirvars') {
        this.formData[key].sort((a, b) => {
          const itemA = this.nirvars.find(item => item.value === a);
          const itemB = this.nirvars.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.text.localeCompare(itemB.text);
          }
          return 0; // Keep original order if items not found
        });
      } else if (key == 'fate_ids') {
        this.formData[key].sort((a, b) => {
          const itemA = this.fateIds.find(item => item.value === a);
          const itemB = this.fateIds.find(item => item.value === b);

          if (itemA && itemB) {
            return itemA.fate - itemB.fate;
          }
          return 0; // Keep original order if items not found
        });
      } else {
        this.formData[key].sort((a, b) => a - b)
      }
    }
  },
}
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 5000px;
}
</style>
